module.exports = require("./nmg.js");